import { Controller } from "../Controller";
import { SearchBox } from "../../HTML/Box/Search/SearchBox";

export class SearchBoxController extends Controller {
    protected initialize(data: Map<any, any>) {
        super.initialize(data);
        this.createSearchBox();
    }

    protected createSearchBox() {
        this.addToData("tag", new SearchBox(this.getData()));
    }
}
